"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isArray = Array.isArray;

exports.default = isArray;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isArray.js
// module id = 1261
// module chunks = 0